export default __webpack_public_path__ + "static/media/featured_tour_01.cbcd22c8.png";